export default {"src":"/_next/static/media/icon-pause.776fcaef.svg","height":28,"width":28};